<div class="ss_view-part"
     (click)="toggleDropdown(searchInput)"
     [ngClass]="{'p-n': noPadding, 'dropup': dropup}"
     [class.disabled]="!data.length">
    <span>{{selectedText}}</span>
</div>

<div class="ss_dropdown" [class.customOptionTemplate]="searchSelectItemTemplate" [class.dropup]="dropup"
     [hidden]="!showDropdown">
    <input class="ss_search-input" [placeholder]="placeholder" [(ngModel)]="searchStr" (ngModelChange)="filteredData()"
           #searchInput
           (keydown.ArrowUp)="onKeydownArrowUp()"
           (keydown.ArrowDown)="onKeydownArrowDown()"
           (keydown.enter)="onKeydownEnter($event)">
    <ng-container *ngIf="searchSelectItemTemplate; else defaultSearchItemTemplate">
        <ul virtualScroller
            #virtualScrollerComponent
            [items]="filteredDataArray"
            [childHeight]="searchSelectItemTemplate.approxHeight"
            [childWidth]="searchSelectItemTemplate.approxWidth"
            (vsUpdate)="visibleItems = $event"
            (vsStart)="startChanged($event)"
            [style.width]="(searchSelectItemTemplate?.approxWidth + 10) + 'px'"
            [style.min-height]="searchSelectItemTemplate.approxHeight + 'px'"
        >
            <ng-container *ngFor="let item of visibleItems; let i = index; trackBy:trackByValue">
                <li
                    (click)="select()"
                    (mouseenter)="focusIndex = i + vsStartIndex"
                >
                    <ng-template [ngTemplateOutlet]="searchSelectItemTemplate.templateRef"
                                 [ngTemplateOutletContext]="{item: item, index: i, focused: isFocused(i), searchTerm: searchStr}"></ng-template>
                </li>
            </ng-container>
            <li *ngIf="filteredDataArray.length === 0">
                <ng-template [ngTemplateOutlet]="searchSelectItemTemplate.templateRef"
                             [ngTemplateOutletContext]="{item: {optionText: noResultsMatchText } }"></ng-template>
            </li>
        </ul>
    </ng-container>

    <ng-template #defaultSearchItemTemplate>
        <ul #defaultScrollContainer>
            <ng-container *ngFor="let item of filteredDataArray; let i = index; trackBy:trackByValue">
                <li
                    [attr.id]="'item-' + item.value"
                    (click)="select()"
                    (mouseenter)="focusIndex = i"
                    [ngClass]="{'focus': i == focusIndex}"
                >{{item.optionText}}</li>
            </ng-container>
            <li *ngIf="filteredDataArray.length === 0">
                {{ noResultsMatchText }}
            </li>
        </ul>
    </ng-template>
</div>

<div class="ss_arrow"
     [class.dropup]="dropup"
     (click)="toggleDropdown(searchInput)"
     [ngStyle]="{'z-index' : showDropdown ? '9999' : '1000'}">
</div>



// WEBPACK FOOTER //
// /app/src/app/components/search-select/search-select.component.html